import { render, staticRenderFns } from "./GameListItem.vue?vue&type=template&id=5393de93&scoped=true&"
import script from "./GameListItem.vue?vue&type=script&lang=js&"
export * from "./GameListItem.vue?vue&type=script&lang=js&"
import style0 from "./GameListItem.vue?vue&type=style&index=0&id=5393de93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5393de93",
  null
  
)

export default component.exports